import cx from 'classnames';
import PropTypes from 'prop-types';

import { InviteUserIcon } from 'src/assets/icons/InviteUser';
import { TRACK_EVENT_SOURCE } from 'src/lib/events';
import { useIsCustomerLocked } from 'src/services';
import { InviteUsersButton } from 'src/views/InviteUsersButton';
import { ViewSubscriptionStatus } from 'src/views/ViewSubscriptionStatus';

import { BookDemoButton } from './BookDemoButton';
import { UserProfile } from './UserProfile';
import { useStyles } from './useStyles';

export const TopNavigationBarItems = ({ className, light }) => {
  const styles = useStyles();
  const isCustomerLocked = useIsCustomerLocked();

  return (
    <div className={cx(styles.root, className, { [styles.light]: light })}>
      <InviteUsersButton
        className={styles.inviteButton}
        startIcon={<InviteUserIcon />}
        source={TRACK_EVENT_SOURCE.navbar}
      />
      <BookDemoButton />
      <ViewSubscriptionStatus />
      <UserProfile disabledSettings={isCustomerLocked} />
    </div>
  );
};

TopNavigationBarItems.propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool,
};
TopNavigationBarItems.defaultProps = {
  className: null,
  light: false,
};
